export const BLOG_PAGE_SIZE = 10;
export const BLOG_REVALIDATE_SECONDS = 60;
export const BLOG_SITE_URL = "https://theplasterpeople.com";
